import React from 'react';
import UsuarioLogadoConsumer from './UsuarioLogadoConsumer';

export const withUsuarioLogado = Component => props => (
  <UsuarioLogadoConsumer>
    <Component {...props} />
  </UsuarioLogadoConsumer>
);
